module.exports = __webpack_public_path__ + "static/media/pravo-povlekuvanje-valandovo.7bf2d223.docx";